import { render, staticRenderFns } from "./PatientDetailConsultation.vue?vue&type=template&id=e08cab34&scoped=true"
import script from "./PatientDetailConsultation.vue?vue&type=script&lang=js"
export * from "./PatientDetailConsultation.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailConsultation.vue?vue&type=style&index=0&id=e08cab34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08cab34",
  null
  
)

export default component.exports